module.exports = __webpack_public_path__ + "static/media/SQSMB.07ca50cd.docx";


//////////////////
// WEBPACK FOOTER
// ./src/identityVerification/modules/attestationType/SQSMB.docx
// module id = 1109
// module chunks = 0